<template>
  <div class="tab_content">
    <p class="tab_title">信息发布</p>
    <div class="tab_form">
      <el-form ref="form" :rules="rules" :model="form" label-width="160px">

        <el-form-item label="公告时间" prop="announcementTimeType">
          <el-radio-group v-model="form.announcementTimeType">
            <el-radio label="工作日">工作日</el-radio>
            <el-radio label="日期选择">日期选择</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item v-if="form.announcementTimeType === '工作日'" label=" ">
          <span>自公告之日起</span>
          <el-input
            v-model="form.announcementTime"
            placeholder="请输入"
            oninput="value=value.replace(/[^\d]/g,'')"
            style="width: 160px; margin: 0 10px"
          />
          <span>个工作日</span>
        </el-form-item>

        <el-form-item v-if="form.announcementTimeType === '日期选择'" label="结束日期">
          <el-date-picker
            v-model="form.endTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请输入"
          />
        </el-form-item>

        <el-form-item label="挂牌期满处理">
          <el-radio-group v-model="form.listedTimeEnd" style="margin-top: 4px">
            <div class="choice">
              <el-radio label="1">更变公告内容，重新挂牌</el-radio>
            </div>
            <div class="choice">
              <el-radio label="2">
                延长信息发布，不变更挂牌条件，按照
                <el-input class="ri" maxlength="3" oninput="value=value.replace(/[^\d]/g,'')" v-model="form.day1" />
                个工作日为一个周期，延长
                <el-input class="ri" maxlength="3" oninput="value=value.replace(/[^\d]/g,'')" v-model="form.delay1" />
                个周期
              </el-radio>
            </div>
            <div class="choice">
              <el-radio label="3">
                延长信息发布，不变更挂牌条件，按照
                <el-input class="ri" maxlength="3" oninput="value=value.replace(/[^\d]/g,'')" v-model="form.day2" />
                个工作日为一周期，直至征集到意向受让方
              </el-radio>
            </div>
            <div class="choice">
              <el-radio label="4">信息发布终结</el-radio>
            </div>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="发布期满后处理">
          <p class="hint-text">
            1、如征集到一家符合条件的意向受让方，在通过受让资格确认后，该意向受让方即为受让方应当以不低于交易底价受让标的；
          </p>
          <p class="hint-text">
            2、如征集到两家及以上符合条件的意向受让方，则采取以下方式确定最终受让方和受让价格。
          </p>
          <el-radio-group v-model="form.releaseTimeEnd" style="margin-top: 4px">
            <el-radio label="网络竞价">网络竞价</el-radio>
            <el-radio label="其他方式">其他方式</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 意向受让资格 -->
        <div class="section-divider">意向受让资格</div>
        <div class="qualification_desc">
          <p>1、意向受让方应为依法设立并有效存续的境内外经济组织或具有完全民事行为能力的自然人；</p>
          <p>2、意向受让方应具有良好的财务状况和支付能力</p>
        </div>
        <el-form-item label-width="0">
          <el-radio-group v-model="form.assigneeQualification">
            <div class="choice long">
              <el-radio label="在登记受让意向时须提供证明其受让能力的资信证明">
                在登记受让意向时须提供证明其受让能力的资信证明
              </el-radio>
            </div>
            <div class="choice">
              <el-radio label="无需提供资信证明">无需提供资信证明</el-radio>
            </div>
          </el-radio-group>
        </el-form-item>
        <div class="qualification_subtitle">3、联合受让</div>
        <el-form-item label-width="0">
          <el-radio-group v-model="form.theJoint">
            <div class="choice long">
              <el-radio label="本项目接受联合受让主体，联合受让主体各方都应当符合受让资格条件，且不得采用委托或者信托等方式参与交易。联合各方应当签订联合受让协议，明确联合体各方承担的责任及相互间的连带责任">
                本项目接受联合受让主体，联合受让主体各方都应当符合受让资格条件，且不得采用委托或者信托等方式参与交易。联合各方应当签订联合受让协议，明确联合体各方承担的责任及相互间的连带责任
              </el-radio>
            </div>
            <div class="choice">
              <el-radio label="本项目不接受联合受让主体">本项目不接受联合受让主体</el-radio>
            </div>
          </el-radio-group>
        </el-form-item>

        <!-- 保证金 -->
        <div class="section-divider">保证金</div>
        <el-form-item label="是否需要保证金">
          <el-radio-group v-model="form.isEarnestMoney">
            <el-radio label="是">是</el-radio>
            <el-radio label="否">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="form.isEarnestMoney === '是'">
          <el-form-item label="保证金金额（万元）">
            <el-input-number
              v-model="form.earnestMoney"
              :min="0"
              :precision="2"
              style="width: 200px"
            />
          </el-form-item>
          <el-form-item label="缴纳截止时间">
            <el-date-picker
              v-model="form.earnestClosingTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </el-form-item>
          <el-form-item label="是否转价款">
            <el-radio-group v-model="form.earnestToMoney">
              <el-radio label="是">是</el-radio>
              <el-radio label="否">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="支付方式">
            <el-select v-model="form.earnestPayTheWay" placeholder="请选择" style="width: 200px">
              <el-option label="支票" value="支票" />
              <el-option label="电汇" value="电汇" />
              <el-option label="网上银行" value="网上银行" />
              <el-option label="其他" value="其他" />
            </el-select>
          </el-form-item>
        </template>

        <el-form-item label="其他条件">
          <el-input
            v-model="form.otherCondition"
            type="textarea"
            :rows="8"
            placeholder="请输入"
          />
        </el-form-item>

        <div class="button flex-center">
          <el-button type="primary" @click="$emit('aChange', 'tab6')">上一步</el-button>
          <el-button type="primary" @click="doStaging('form')">暂存</el-button>
          <el-button type="success" @click="doSubmit('form')">提交审核</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { postRequest } from "../../../api/api";
export default {
  props: ["id", "cfrom", "projType"],
  data() {
    return {
      form: {
        announcementTimeType: "工作日",
        announcementTime: "",
        endTime: "",
        listedTimeEnd: "2",
        day1: null,
        day2: null,
        delay1: null,
        releaseTimeEnd: "网络竞价",
        assigneeQualification: "无需提供资信证明",
        theJoint: "本项目不接受联合受让主体",
        isEarnestMoney: "否",
        earnestMoney: null,
        earnestClosingTime: "",
        earnestToMoney: "否",
        earnestPayTheWay: "",
        otherCondition: `1、本项目对外公告之日即进入尽职调查期，意向受让方在本项目公告期间有权利和义务自行对交易标的进行全面了解。
2、意向受让方应在公告期内向上海知识产权交易中心递交受让申请文件。
3、信息发布期满，如只征集到一个符合条件的意向受让方的，按照挂牌价成交；如征集到两个及以上符合条件的意向受让方的，采用网络竞价方式确定受让方和受让价格。
4、为保护交易各方合法利益，申请人在此做出特别提示。
5、本次交易基本服务费自《交易合同》签订之日起 xx 个工作日内由   双方  支付。`,
      },
      rules: {
        announcementTimeType: [{ required: true, message: "请选择公告时间类型" }],
      },
    };
  },
  methods: {
    buildValue() {
      const v = { ...this.form };
      if (v.isEarnestMoney === "否") {
        v.earnestMoney = null;
        v.earnestClosingTime = "";
        v.earnestToMoney = "";
        v.earnestPayTheWay = "";
      }
      v.projType = 0;
      if (this.id) v.id = this.id;
      return v;
    },
    doStaging(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) this.$emit("aStagin", this.buildValue());
      });
    },
    doSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) this.$emit("submit", this.buildValue());
      });
    },
  },
  watch: {
    cfrom() {
      if (!this.cfrom || !this.cfrom.id) return;
      const c = this.cfrom;
      this.form = {
        announcementTimeType: c.announcementTimeType || "工作日",
        announcementTime: c.announcementTime || "",
        endTime: c.endTime || "",
        listedTimeEnd: c.listedTimeEnd || "2",
        day1: c.day1 || null,
        day2: c.day2 || null,
        delay1: c.delay1 || null,
        releaseTimeEnd: c.releaseTimeEnd || "网络竞价",
        assigneeQualification: c.assigneeQualification || "无需提供资信证明",
        theJoint: c.theJoint || "本项目不接受联合受让主体",
        isEarnestMoney: c.isEarnestMoney || "否",
        earnestMoney: c.earnestMoney || null,
        earnestClosingTime: c.earnestClosingTime || "",
        earnestToMoney: c.earnestToMoney || "否",
        earnestPayTheWay: c.earnestPayTheWay || "",
        otherCondition: c.otherCondition || "",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.tab_content {
  margin: 0 30px;
  .tab_title {
    font-size: 18px;
    font-weight: 500;
  }
  .tab_form {
    margin-top: 20px;
    .section-divider {
      font-size: 15px;
      font-weight: 500;
      color: #303133;
      margin: 20px 0 16px;
      padding: 8px 12px;
      background: #f5f7fa;
      border-left: 4px solid #409eff;
      border-radius: 0 4px 4px 0;
    }
    .hint-text {
      font-size: 13px;
      color: #606266;
      margin: 0 0 4px;
    }
    .qualification_desc {
      margin-bottom: 8px;
      p {
        margin: 0 0 8px;
        color: #303133;
        line-height: 22px;
      }
    }
    .qualification_subtitle {
      margin: 12px 0 10px;
      color: #303133;
      line-height: 22px;
      font-weight: 500;
    }
    .button {
      button {
        width: 160px;
        margin: 0 24px;
        display: block;
      }
    }
    .choice {
      margin: 0 0 10px;
      &.long .el-radio {
        display: flex;
        white-space: normal !important;
        align-items: flex-start;
      }
    }
    .ri {
      width: 60px;
      display: inline-block;
    }
  }
}
</style>
